export default {
  props: {
    accessStatus: {
      default: 'unactivated',
    },
  },
}
